import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OperationsService } from '../../../../../../core/services/operations.service';
import { DannoBiologico } from '../../../../../models/danno-biologico/danno-biologico';
import { DannoBiologicoAdapter } from '../../../../../models/danno-biologico/danno-biologico-adapter';
import { SezioneEconomica } from '../../../../../models/sezioni/sezione-economica';

@Component({
  selector: 'app-personalizzazione-danno-biologico-form',
  templateUrl: './personalizzazione-danno-biologico-form.component.html',
  styleUrls: ['./personalizzazione-danno-biologico-form.component.css']
})
export class PersonalizzazioneDannoBiologicoFormComponent implements OnInit {

  dannoBiologico: DannoBiologico;
  dannoBiologicoForm: FormGroup;
  urlDannoBiologico: string;
  idSezione: string;
  idFascicolo: string;
  tipoPraticaEndpoint: string;
  genericFascicolo: string;
  dannoBiologicoOrigin: DannoBiologico;
  @Input() sezione: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>()
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>()

  viewForm: boolean = false;

  constructor( private campiForm: FormBuilder, private ops: OperationsService) { }

  inizializza(sezione: SezioneEconomica, genericFascicolo: string, idFascicolo: string, tipoPraticaEndpoint: string){
    //this.urlDannoBiologico = OperationsUrlSettingsFascicoloIns.ops.URL_ADD_SEZIONE_ECONOMICA_DANNO_BIOLOGICO(genericFascicolo);
    this.idSezione = sezione.id;
    this.idFascicolo = idFascicolo;
    this.tipoPraticaEndpoint = tipoPraticaEndpoint;
    this.genericFascicolo = genericFascicolo;
    if(sezione.dannoBiologico){
      this.dannoBiologico = new DannoBiologicoAdapter(sezione.dannoBiologico);
      this.dannoBiologicoOrigin = {...this.dannoBiologico};
      console.log(this.dannoBiologico)
    }else{
      this.dannoBiologico = new DannoBiologico();
    }
    this.dannoBiologicoForm = this.campiForm.group({
    patologia: [this.dannoBiologico.patologia, Validators.required],
    dataDiagnosi: [this.dannoBiologico.dataDiagnosi, Validators.required],
    dataDecesso: [this.dannoBiologico.dataDecesso],
    riconoscimentoMalattiaProfessionale: [this.dannoBiologico.riconoscimentoMalattiaProfessionale, Validators.required],
    dataRiconoscimentoMalattiaProfessionale: [this.dannoBiologico.dataRiconoscimentoMalattiaProfessionale],
    percentualeInvalidita: [this.dannoBiologico.percentualeInvalidita],
    numeroGiorniInvaliditaTemp: [this.dannoBiologico.numeroGiorniInvaliditaTemp],
    dataRilevazioneInvaliditaTemp: [this.dannoBiologico.dataRilevazioneInvaliditaTemp],
    importoDannoBiologico: [this.dannoBiologico.importoDannoBiologico],
    importoDannoMorale: [this.dannoBiologico.importoDannoMorale],
    importoDannoMoraleEredi: [this.dannoBiologico.importoDannoMoraleEredi],
    importoInvaliditaTemp: [this.dannoBiologico.importoInvaliditaTemp],
    note: [this.dannoBiologico.note],
    totalePreAbbattimento: [this.dannoBiologico.totalePreAbbattimento],
    percentualeAbbattimento: [this.dannoBiologico.percentualeAbbattimento],
    totale: [this.dannoBiologico.totale],
    })
    this.viewForm = true;
  }

  ngOnInit() {
  }
  save(){
    if(this.dannoBiologico.id){
      this.ops.modificaDannoBiologico(this.tipoPraticaEndpoint, this.dannoBiologico, this.idSezione, this.idFascicolo, this.genericFascicolo).subscribe(res => {
        if(res)
          this.onReturn.emit(res.sezione)
          console.log(res)
      })
    }else{
      this.ops.addDannoBiologico(this.tipoPraticaEndpoint, this.dannoBiologico, this.idSezione, this.idFascicolo, this.genericFascicolo).subscribe(res => {
        if(res)
          this.onReturn.emit(res.sezione)
          console.log(res)
      })
    }
  }

  cambioValidita(malattiaProfessionale){
    if(malattiaProfessionale){
      this.dannoBiologicoForm.controls['dataRiconoscimentoMalattiaProfessionale'].setValidators([Validators.required]);
      this.dannoBiologicoForm.controls['dataRiconoscimentoMalattiaProfessionale'].updateValueAndValidity();
    }else{
      this.dannoBiologicoForm.controls['dataRiconoscimentoMalattiaProfessionale'].clearValidators();
      this.dannoBiologicoForm.controls['dataRiconoscimentoMalattiaProfessionale'].updateValueAndValidity();
    }
  }

  reset(){
    if(this.dannoBiologico.id)
      this.dannoBiologico = new DannoBiologicoAdapter(this.dannoBiologicoOrigin);
      else this.dannoBiologico = new DannoBiologico();

    this.cambioValidita(this.dannoBiologico.riconoscimentoMalattiaProfessionale)

  }
}
